// 工单标签
<template>
	<div id="containt">
		<el-tabs v-model="activeName" class="tab-box">
			<el-tab-pane label="常规" name="first">
				<editView v-if="showEdit" visible-key="showEdit" :_dataId.sync="dataId" :parent-target="_self"
					@reload="$reloadHandle" @goBackIndex="goBackIndex"></editView>
			</el-tab-pane>
			<el-tab-pane label="列表" name="second">
				<div class="grid-height" style="height: calc(100vh - -35px);">
					<vxe-grid
					:stripe="true" border="default" :row-config="{ isHover: true }" show-overflow height="100%"
					ref="table-m1" v-bind="vxeOption" @resizable-change="$vxeTableUtil.onColumnWitchChange"
						@custom="$vxeTableUtil.customHandle">

						<template #form>
							<div class="clearfix screen-btns">
								<div class="fl">
									<vxe-button status="primary" class="button-sty" icon="el-icon-plus"
										@click="openEditDialog" v-if="dispatchStatAdd">新增</vxe-button>
								</div>
								<div class="fr">
<!--									<vxe-button icon="el-icon-brush" class="button-sty" @click="resetEvent" type="text"-->
<!--										status="primary" plain>重置</vxe-button>-->
									<vxe-button status="warning" icon="el-icon-search" class="button-sty"
										@click="searchEvent">搜索</vxe-button>
								</div>
							</div>
							<vxe-form ref="form" class="screen-box" title-width="92px" title-align="right" :data="formData"
							@submit="toFilterData" @keyup.enter.native="toFilterData" @reset="searchEvent">
								<vxe-form-item title="工单标签:" field="name">
									<template v-slot>
										<el-input v-model="searchDispatchStat" size="small" clearable />
									</template>
								</vxe-form-item>
								<!-- <vxe-form-item title="考核编码:" field="name">
									<template v-slot>
										<el-input v-model="formData.name" size="small" clearable />
									</template>
								</vxe-form-item> -->
							</vxe-form>
						</template>
						<template #pager>
              <pager ref="pager" :page-sizes="pageSizes" @changeTablePage="changeTablePage"></pager>
            </template>
					</vxe-grid>
				</div>
			</el-tab-pane>
		</el-tabs>
	</div>
</template>

<script>
import editView from './edit.vue';
import { tableOption } from '@/const/crud/admin/tenant';
import { initVxeTable } from '@/const/crud/admin/table';
import pager from '@/components/pager/index.vue'
import {mapGetters} from "vuex";
import {indexPageMixins} from "@/mixins/tabChang";
export default {
	name: 'attemper',

  mixins: [indexPageMixins],
	components: { editView, pager },
	data() {
		return {
      dispatchStatAdd: false,
      dispatchStatEdit: false,
      total: 0,
			activeName: 'second',
			dataId: 0,
			showEdit: false,
			vxeOption: {},
      editViewDataUpdateFlag: false,
      searchDispatchStat : '',
			// 查询参数
			formData: {
				searchCount: false,  // 是否分页
				current: 1,  // 当前页面
				size: 0,  // 页面数据量
        dispatchStat:'' //工单标签
			},
			pageSizes: [10, 20, 100]
		};
	},
	mounted() {
		// this.initTableList();
	},
  watch: {
    total(newVal) {
      this.$refs.pager.tableDataTotal = newVal
    },
    // activeName(newVal) {
    //   if (newVal === 'second' && this.editViewDataUpdateFlag) {
    //     this.initTableList()
    //   }
    // }
  },
  computed: {
    ...mapGetters(["permissions"])
  },
  created() {
    this.dispatchStatEdit = this.permissions['dispatch_stat_edit']
    this.dispatchStatAdd = this.permissions['dispatch_stat_add']
  },
	methods: {
		toFilterData() {
          // console.log(55,"触发了搜索");
    // 当用户没有输入内容就按enter键时，就return，不做任何操作，不去搜索
        if(this.formData === '') {
             return
        } else {
        // 请求查询接口，将列表展现出来
            this.searchEvent();
         }
     },

    // 刷新
    flushed() {
      this.$refs['table-m1'].commitProxy('reload');
    },

		// 分页功能
		changeTablePage(page, flag) {
			console.log('分页数据', page, this.formData)
			this.formData.size = page.pageSize
			this.formData.current = page.currentPage
			this.formData.searchCount = flag
			this.getTableData();
		},
		// 搜索
		searchEvent() {

      this.formData.dispatchStat = this.searchDispatchStat
      this.$refs.pager.clearStoreTableDataTotal()
      this.formData.current = 1
      this.formData.searchCount = false
      this.$refs.pager.reset()  // 重置分页器
      this.flushed()

		},
		// 重置
		resetEvent() {
      this.formData.searchCount = false
      this.formData.current= 1
      this.formData.dispatchStat = ''
      this.searchDispatchStat = ''
      this.$refs.pager.reset()  // 重置分页器
      this.flushed()
		},
    editViewDataUpdate() {
      this.editViewDataUpdateFlag = true;
    },
		// 新增
		openEditDialog(id) {
			this.dataId = !id || typeof id == 'object' ? 0 : id;
			this.activeName = 'first';
			this.$openEditView('showEdit');
		},
		getTableData() {
			let that = this;
			let tableOption = {
				vue: this,
				tableRef: 'table-m1',
				tableName: 'basic_fault_code_list-m1',
				path: '/basic/basDispatchStat/getListPage',
				param: this.formData,
				method: 'post',
				height: '800px',
				columns: [
					{ type: 'seq', width: 60, title: '序号', resizable: false, fixed: 'left' },
					{
						title: '工单标签',
						field: 'dispatchStat',
						width: 150,
						// fixed: 'left'
					},
					{
						title: '工单查询栏目是否显示',
						field: 'isShow',
						width: 150,
						slots: {
							default: ({ row }) => {
								if (row.isShow == 0) {
									return [
										<div class="txt-status disable">
											<span>否</span>
										</div>
									];
								} else if (row.isShow == 1) {
									return [
										<div class="txt-status">
											<span>是</span>
										</div>
									];
								}
							}
						}
					},	{
						title: '网点备注操作是否显示',
						field: 'showInSiteRemark',
						width: 150,
						slots: {
							default: ({ row }) => {
								if (row.showInSiteRemark == 0) {
									return [
										<div class="txt-status disable">
											<span>否</span>
										</div>
									];
								} else if (row.showInSiteRemark == 1) {
									return [
										<div class="txt-status">
											<span>是</span>
										</div>
									];
								}
							}
						}
					},

					{
						title: '总部备注操作是否显示',
						field: 'showInRemark',
						width: 150,
						slots: {
							default: ({ row }) => {
								if (row.showInRemark == 0) {
									return [
										<div class="txt-status disable">
											<span>否</span>
										</div>
									];
								} else if (row.showInRemark == 1) {
									return [
										<div class="txt-status">
											<span>是</span>
										</div>
									];
								}
							}
						}
					},
					{
						title: '显示颜色',
						field: 'color',
						width: 150,
						slots: {
							default: ({ row }) => {
								if (row.color == 0) {
									return [
										<div>
											<span>不显示</span>
										</div>
									];
								} else if (row.color == 1) {
									return [
										<div>
											<span>yellow</span>
										</div>
									];
								}else if (row.color == 2) {
									return [
										<div>
											<span>green</span>
										</div>
									];
								}else if (row.color == 3) {
									return [
										<div>
											<span>red</span>
										</div>
									];
								}
							}
						}
					},
					{
						field: 'createTime',
						title: '创建时间',
						width: 150
					},
					{
						title: '创建人',
						field: 'createBy',
						width: 150,

					},
					{
						width: 47,
						fixed: 'right',
						title: '',
						sortable: false,
						slots: {
							default: ({ row }) => {
								return [
									<div>
										<a
											href="javascript:void(0);"
											class="a-link"
											onclick={() => {
												this.openEditDialog(row.id);
											}}
										>
											<el-tooltip enterable={false} effect="dark" content="查看" placement="top" popper-class="tooltip-skin">
												<i class="el-icon-edit" />
											</el-tooltip>
										</a>
									</div>
								];
							}
						}
					}
				]
			};
			// initVxeTable(tableOption).then(opts => {
			this.vxeOption = initVxeTable(tableOption);
      this.editViewDataUpdateFlag = false;
      this.flushed()
		},
	}
};
</script>
<style lang="scss" >
/* 注意此处不能有scoped 否则样式无法生效 */
.el-cascader-panel {
	.el-radio__inner {
		border: 0px;
		background: transparent;
	}

	.el-radio__input.is-checked .el-radio__inner {
		background: none;
	}

	.el-radio {
		height: 100%;
		width: 150px;
		position: absolute;
		z-index: 10;
	}
}</style>
